<script setup lang="ts">
import { useRoute } from 'vue-router';
import { useAbility } from '@casl/vue';

import * as routeNames from '@/constants/routeNames';

import tabsStyles from '@/styles/tabs.module.scss';

const route = useRoute();

const ability = useAbility();
const isStaff = ability.can('staff', 'Job');
</script>

<template>
  <div :class="[$style.smartSearchTabs, tabsStyles.tabsWrapper]">
    <v-tabs :class="tabsStyles.tabs" :model-value="route.name">
      <v-tab
        :to="{ name: routeNames.SEARCH_ADVANCED }"
        :value="routeNames.SEARCH_ADVANCED"
        :ripple="false"
        :class="tabsStyles.tab"
        variant="plain"
      >
        Advanced
      </v-tab>
      <v-tab
        :to="{ name: routeNames.SEARCH_JOB_ID }"
        :value="routeNames.SEARCH_JOB_ID"
        :ripple="false"
        :class="tabsStyles.tab"
        variant="plain"
      >
        Job ID
      </v-tab>
      <v-tab
        v-if="isStaff"
        :to="{ name: routeNames.SEARCH_POSTCODE }"
        :value="routeNames.SEARCH_POSTCODE"
        :ripple="false"
        :class="tabsStyles.tab"
        variant="plain"
      >
        Postcode
      </v-tab>
      <v-tab
        :to="{ name: routeNames.SEARCH_SUBURBS }"
        :value="routeNames.SEARCH_SUBURBS"
        :ripple="false"
        :class="tabsStyles.tab"
        variant="plain"
      >
        Suburbs
      </v-tab>
    </v-tabs>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.smartSearchTabs {
}
</style>
